module.exports = __webpack_public_path__ + "img/ic-speaker.4b4309e5.png";